<div class="auth-container">
	<div class="auth-wrapper">
		<figure class="auth-logo">
			<img src="./assets/images/logo-ivsw.svg" alt="Logo IVSW" />
		</figure>
		<app-password-forget-form (requestResetPassword)="submit($event)"></app-password-forget-form>
	</div>
</div>
